import { Dispatch } from "redux"

import { CLOSE_MODAL, OPEN_MODAL, SET_ACCOUNT, CLEAR_ACCOUNT, CLEAR_SYSTEM_EVENTS } from "./actions-types"

export function changeModalState(isOpen: boolean, type: string) {
  return (dispatch: Dispatch) => {
    if (isOpen) return dispatch({ type: OPEN_MODAL, payload: { type } })

    return dispatch({ type: CLOSE_MODAL })
  }
}

export function setAccount(params: App.Account) {
  return (dispatch: Dispatch) => {
    dispatch({ type: SET_ACCOUNT, payload: params })
  }
}

export function clearAccount() {
  return (dispatch: Dispatch) => {
    dispatch({ type: CLEAR_ACCOUNT })
  }
}

export function clearSystemEvents() {
  return (dispatch: Dispatch) => {
    dispatch({ type: CLEAR_SYSTEM_EVENTS })
  }
}
